import { ComplexValue, ValidationProps, ValidationLevel } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodetableTranslation } from 'app/area/codetable/constants';

export const validateComplexValue = (
  key: keyof CodeItem,
  codeItem: CodeItem,
  translation: CodetableTranslation
): { [key in keyof CodeItem]?: ValidationProps } => {

  const property = codeItem[key] as ComplexValue;

  return {
    [key]: !!property && isDefinedIncludingZero(property.value) ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};

export const validateIfFilledOut = (
  key: keyof CodeItem,
  condition: boolean,
  translation: CodetableTranslation
): { [key in keyof CodeItem]?: ValidationProps } => {

  return {
    [key]: condition ? undefined : {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.must_be_filled_out
      }]
    }
  };
};

export const validateIfNotEqual = (
  firstKey: keyof CodeItem,
  secondKey: keyof CodeItem,
  codeItem: CodeItem,
  message: string
): { [key in keyof CodeItem]?: ValidationProps } => {

  const firstProperty = codeItem[firstKey] as ComplexValue;
  const secondProperty = codeItem[secondKey] as ComplexValue;

  const arePropertiesEqual = !!firstProperty && !!secondProperty && firstProperty.value === secondProperty.value;

  return arePropertiesEqual
    ? {
      [firstKey]: {
        level: ValidationLevel.error,
        messages: [{
          level: ValidationLevel.error,
          message
        }]
      },
      [secondKey]: {
        level: ValidationLevel.error,
        messages: [{
          level: ValidationLevel.error
        }]
      }
    } : undefined;
};
